/**
 * /translation-terms client — IAA-generator translation registry
 * (#50 stage 2, migration 0036). Mirrors completenessRulesApi.
 */
import { api } from './client';
import type {
  DocumentLanguage,
  Page,
  TranslationTerm,
  TranslationTermCreateInput,
  TranslationTermDomain,
  TranslationTermUpdateInput,
  UUID,
} from './types';

export const translationTermsApi = {
  list: (
    domain?: TranslationTermDomain,
    language?: DocumentLanguage,
  ): Promise<Page<TranslationTerm>> => {
    // 200 = the Page schema's hard cap (asking for 500 was the 2026-06-12
    // Translations-tab 500). Registry growth beyond 200 rows would need
    // paging here, not a bigger limit.
    const params = new URLSearchParams({ limit: '200' });
    if (domain) params.append('domain', domain);
    if (language) params.append('language', language);
    return api.get(`/translation-terms?${params}`);
  },
  create: (input: TranslationTermCreateInput): Promise<TranslationTerm> =>
    api.post('/translation-terms', input),
  update: (id: UUID, input: TranslationTermUpdateInput): Promise<TranslationTerm> =>
    api.patch(`/translation-terms/${id}`, input),
  delete: (id: UUID): Promise<TranslationTerm> =>
    api.delete(`/translation-terms/${id}`),
};
